"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSafeConfigValue = exports.useSafeConfigSlice = exports.getSafeConfigValue = exports.default = void 0;
var _ = require("..");
var _index = _interopRequireDefault(require("./index.schema"));
const useSafeConfigSlice = function (keys) {
  const config = (0, _.useConfig)();
  const pickShape = Object.fromEntries(keys.map(function (key) {
    return [key, true];
  }));
  const schema = _index.default.pick(pickShape);
  return schema.parse(config);
};
exports.useSafeConfigSlice = useSafeConfigSlice;
const useSafeConfigValue = function (key) {
  const config = (0, _.useConfig)();
  const pickShape = {
    [key]: true
  };
  const schema = _index.default.pick(pickShape);
  const slice = schema.parse(config);
  return slice[key];
};
exports.useSafeConfigValue = useSafeConfigValue;
const getSafeConfigValue = function (config, key) {
  const pickShape = {
    [key]: true
  };
  const schema = _index.default.pick(pickShape);
  const slice = schema.parse(config);
  return slice[key];
};
exports.getSafeConfigValue = getSafeConfigValue;
const useSafeConfig = function () {
  const config = (0, _.useConfig)();
  return _index.default.parse(config);
};
var _default = exports.default = useSafeConfig;